/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { setProductBundleReadyForInitialRender } from '@atlassian/jira-spa-performance-breakdown/src/utils/performance-marks-tools/index.tsx';

export const markAsProductBundleReady = <T,>(importedBundle: Promise<T>): Promise<T> => {
	if (!__SERVER__) {
		importedBundle.then(() => {
			setProductBundleReadyForInitialRender();
		});
	}
	return importedBundle;
};
